export class Product {
    constructor(qonversionId, storeId, basePlanId, purchaseOptionId, storeDetails, skProduct, offeringId, subscriptionPeriod, trialPeriod, type, prettyPrice, price, currencyCode, storeTitle, storeDescription, prettyIntroductoryPrice) {
        this.qonversionId = qonversionId;
        this.storeId = storeId;
        this.basePlanId = basePlanId;
        this.purchaseOptionId = purchaseOptionId;
        this.storeDetails = storeDetails;
        this.skProduct = skProduct;
        this.offeringId = offeringId;
        this.subscriptionPeriod = subscriptionPeriod;
        this.trialPeriod = trialPeriod;
        this.type = type;
        this.prettyPrice = prettyPrice;
        this.price = price;
        this.currencyCode = currencyCode;
        this.storeTitle = storeTitle;
        this.storeDescription = storeDescription;
        this.prettyIntroductoryPrice = prettyIntroductoryPrice;
    }
}
//# sourceMappingURL=Product.js.map